import React from 'react';
import { connect } from 'react-redux';
import { HorizontalBar } from 'react-chartjs-2';
import { dateConverter } from '../../../../helper/Helper';

const AllCompanyLimitStats = (props) => {
    const { tagCount, tagLimit, companyMembersLimit, totalActiveCompanyMembers, commons, productOrder, modalInfoTextStyle } = props;

    // calculation of limits   
    const percentageOfTagCount = Math.round(tagLimit > 0 ? (tagCount / tagLimit) * 100 : 0);
    const percentageOfCompanyMembersLimit = Math.round(companyMembersLimit > 0 ? (totalActiveCompanyMembers / companyMembersLimit) * 100 : 0);

    // progress bar color
    const progressBarColorBasedOnPercentageOfCompanyMembersLimit = percentageOfCompanyMembersLimit > 0 && percentageOfCompanyMembersLimit <= 70 ? "green" : percentageOfCompanyMembersLimit > 70 && percentageOfCompanyMembersLimit <= 85 ? "Gold" : "OrangeRed";
    const progressBarColorBasedOnPercentageOfTagLimit = percentageOfTagCount > 0 && percentageOfTagCount <= 70 ? "green" : percentageOfTagCount > 70 && percentageOfTagCount <= 85 ? "Gold" : "OrangeRed";

    // chartjs2 based slider bars
    const tagData = {
        labels: ['%'],
        datasets: [
            {
                label: `Limit (${tagCount}/${tagLimit !== '-1' ? tagLimit : `${commons.unlimited}`})`,
                data: [percentageOfTagCount],
                backgroundColor: [
                    'rgba(20, 56, 150, 0.4)',
                ],
                borderColor: [
                    'rgba(20, 56, 150, 1)',
                ],
                borderWidth: 1,
            }
        ],
    };

    const companyMemberData = {
        labels: ['%'],
        datasets: [
            {
                label: `Limit (${totalActiveCompanyMembers}/${companyMembersLimit !== '-1' ? companyMembersLimit : `${commons.unlimited}`})`,
                data: [percentageOfCompanyMembersLimit],
                backgroundColor: [
                    'rgba(20, 56, 150, 0.4)',
                ],
                borderColor: [
                    'rgba(20, 56, 150, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        showLines: true,
        // maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            xAxes: [
                {
                    ticks: {
                        // display: false,
                        stepSize: 50,
                        min: 0,
                        max: 100,
                    }
                }
            ]
        }
    }

    return (
        <div className="card p-2" style={{ borderRadius: '15px', overflow: 'auto' }}>

            {/* Card header */}
            <div className="card-header bg-white p-0 mx-2 mb-2">
                <div className="row">
                    <div className="col-12">
                        <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Limit tracker</p>
                        <p style={modalInfoTextStyle}>Keep track of company limits.</p>
                    </div>
                </div>
            </div>

            {/* Card body */}
            <div className="card-body">
                <HorizontalBar data={companyMemberData} width={100} height={20} options={{
                    ...options, title: {
                        display: true,
                        text: `${commons.ucompanyMemberUsage}: (${totalActiveCompanyMembers}/${companyMembersLimit !== '-1' ? companyMembersLimit : `${commons.unlimited}`})`,
                        fontSize: 13,
                    },
                }} />
                <HorizontalBar data={tagData} width={100} height={20} options={{
                    ...options, title: {
                        display: true,
                        text: `${commons.utagUsage}: (${tagCount}/${tagLimit !== '-1' ? tagLimit : `${commons.unlimited}`})`,
                        fontSize: 13,
                    },
                }} />
                <p style={{ fontSize: '13px', color: '#7a7a7a', fontWeight: 'bold', marginTop: '5px' }}>{commons.uprojectTagLimit}: {productOrder.projectTagLimit}</p>
                <br />
                {productOrder ? productOrder.tierid==="tier_free" ? <React.Fragment> </React.Fragment> : <p style={{ fontSize: '13px' }}>{commons.utagLimit} resets on <u>{dateConverter(productOrder.periodEnd * 1000).parsedDate}</u></p> : <React.Fragment />}
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        commons: state.commons,
        productOrder: state.firestore.data.ProductOrder,

        // styles
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalStyles: state.appControl.modalStyles,
    }
}

export default connect(mapStateToProps)(AllCompanyLimitStats)
